import { $translate } from '@/utils/i18n';
export default {
    searchList: {
        'searchTxt': [],
        'isInquire': false
    },
    table: {
        'height': 200,
        'selectBtn': true,
        'leftWidth': 200,
        'columns': [
            {
                'label': $translate('lang.E3202103090025', { defaultText: '规则编码' }),
                'prop': 'identityRule',
                'width': 180
            },
            {
                'label': $translate('lang.E3202103090026', { defaultText: '规则名称' }),
                'prop': 'rulesName',
                'width': 200
            },
            {
                'label': $translate('lang.E3202103090027', { defaultText: '二维码内容示例' }),
                'prop': 'relesValue',
                'width': 200
            }
        ],
        leftOperation: false
    },
    showPage: false
};
